module.exports = __webpack_public_path__ + "img/frame_degree_s_2.caff71bc.png";